import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { string } from 'prop-types'

// Components
import { IconHome } from 'src/Components/shared/Icon'
import { Text, Button } from 'src/Components'

// Styles
import baseStyles from '../ListingsCarousel.module.scss'
import styles from './LastSlide.module.scss'

const LastSlide = ({ id, url, className }) => (
  <div className={styles.lastListingContainer}>
    <Button.ExternalListingsButton
      key={id}
      className={classnames(baseStyles.buttonParent, className)}
      listingsUrl={url}
    >
      <IconHome
        className={styles.homeIcon}
        variant='neutralCool'
        variantCount='900'
      />
      <Text
        className={styles.lastSlideText}
        variant='neutralCool'
        variantCount='900'
      >
        <FormattedMessage
          id='MarketSpotLight.ylopoListings.see.more.slide'
          defaultMessage='Want to see even more homes?'
        />
      </Text>
      <Text size='s' variant='secondary' variantCount='600'>
        <FormattedMessage
          id='MarketSpotLight.ylopoListings.see.all.button'
          defaultMessage='View more'
        />
      </Text>
    </Button.ExternalListingsButton>
  </div>
)

LastSlide.propTypes = {
  id: string,
  url: string,
  className: string,
}

export default LastSlide
